<template>

    <v-modal :title="$t('labels.create_location')">
        <template #alert>
            <v-alert-upgrade feature="locations" />
        </template>
        <template #body>
            <v-alert :message="error" />
            <v-form-group :label="$t('labels.name')">
                <v-input maxlength="100" :model="params.name" @input="params.name = $event" />
            </v-form-group>
        </template>
        <template #footer>
            <v-button size="sm" theme="white" @click.native="cancel">{{ $t('labels.cancel') }}</v-button>
            <v-button size="sm" :loading="loading" @click.native="createLocation">{{ $t('labels.create') }}</v-button>
        </template>
    </v-modal>

</template>

<script>

import ProjectApi from '@api/ProjectApi';

import Modal from '@cmp/Modal';

export default {

    components: {
        'v-modal': Modal,
    },

    data() {
        return {
            loading: false,
            error: null,
            params: {},
        }
    },

    methods: {

        createLocation() {
            this.loading = true;
            ProjectApi.createLocation(this.project.id, this.params)
                .then((response) => {
                    this.loading = false;
                    this.$store.commit('setAlertSuccess', this.$t('messages.saved'));
                    this.$store.commit('setModal', null);
                    this.$emit('saved');
                })
                .catch((error) => {
                    this.loading = false;
                    this.error = error.response.data.message;
                });
        },

        cancel() {
            this.$store.commit('setModal', null);
        },

    },

}

</script>
